module.exports = __webpack_public_path__ + "media/images/mailers/welcome_email/iphone-021da89a7bf9e7858888cd220a6e8091.png";